import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useNavigate } from "react-router";
import { MdOutlineLocalActivity } from "react-icons/md";
import { LuChevronRight, LuStar, LuWallet } from "react-icons/lu";
import { emptyStateIllustrations } from "../assets/empty-states";
import HiOutlineSlotMachine from "../assets/imgs/slotMachineIcon";
import { Card, CardHeader, Coupon, Loading, PageWrapper, QueryState } from "../components/blocks";
import { Apis } from "../util/Apis";
import { formatNumber } from "./Cashless";

const Resumen = () => {
  const salaInfo = JSON.parse(localStorage.getItem("salaInfo"));

  const { data: dataCoupon, isLoading: loadingCoupon, error: errorCoupon } = useQuery({
    queryKey: ["point-coupons", salaInfo?.salaId],
    queryFn: async () => {
      const res = await axios.get(Apis.CAPP + "/point-coupons?salaId=" + salaInfo.salaId);
      return res.data;
    },
    enabled: !!salaInfo?.salaId,
  });

  const { data: dataCashLess } = useQuery({
    queryKey: ["cashless", salaInfo?.salaId],
    queryFn: async () => {
      const res = await axios.get(Apis.CAPP + "/cashless?salaId=" + salaInfo.salaId);
      return res.data;
    },
    enabled: !!salaInfo?.salaId,
  });

  const navigate = useNavigate();

  function detalleCupones(id) {
    navigate("/detalle-cupones/" + id);
  }

  function goCashless() {
    navigate("/cashless");
  }

  function goPuntos() {
    navigate("/puntos");
  }

  return (
    <PageWrapper>
      {loadingCoupon ? (
        <Loading />
      ) : (
        <div className="flex flex-col w-full gap-4">
          {salaInfo.salaId === 999 && (
            <Card variant="dark" onClick={goCashless}>
              <CardHeader
                title="Billetera digital"
                subtitle="Saldo actual"
                icon={<LuWallet size={24} />}
                variant="dark"
              />
              <div className="flex flex-row items-center justify-between w-full gap-1 px-2">
                <span className="text-2xl font-extrabold leading-tight">
                  {"S/ " + formatNumber(dataCashLess?.currentAmount || 0)}
                </span>
                <LuChevronRight size={20} />
              </div>
            </Card>
          )}

          {dataCoupon?.activity?.inPlay && (
            <Card variant="primary">
              <CardHeader
                title="Sesion actual"
                subtitle="Maquina en juego"
                icon={<HiOutlineSlotMachine size={24} />}
                variant="primary"
              />
              <div className="flex flex-row items-baseline w-full gap-1 px-2">
                <span className="font-normal">Maq.</span>
                <span className="text-lg font-extrabold">{dataCoupon.activity.machine}</span>
              </div>
            </Card>
          )}

          <Card onClick={goPuntos}>
            <CardHeader title="Puntos" subtitle="Total de puntos" icon={<LuStar size={24} />} />
            <div className="flex flex-row items-center justify-between w-full gap-1 px-2">
              <div className="flex flex-row items-baseline gap-1">
                <span className="text-2xl font-extrabold">{Math.floor(dataCoupon?.points || 0)}</span>
                <span className="font-normal text-slate-600">puntos</span>
              </div>
              <LuChevronRight size={20} />
            </div>
          </Card>

          <CardHeader
            title="Cupones"
            subtitle="Lista de cupones activos"
            icon={<MdOutlineLocalActivity size={24} />}
          />

          <QueryState
            data={dataCoupon?.coupons}
            isLoading={loadingCoupon}
            error={errorCoupon}
            emptyProps={{
              title: "Parece que no hay cupones disponibles",
              subtitle: "Pregunte a un administrador por mas informacion",
              illustration: emptyStateIllustrations.coupons,
              illustrationAlt: "Sin cupones activos",
            }}
          >
            {(coupons) => (
              <>
                {coupons.map((item) => (
                <Coupon
                  key={item.id}
                  couponName={item.couponName}
                  printable
                  available={item.available}
                  hexColor={item.hexColor}
                  multiplier={item.multiplier}
                  percentage={typeof item.percentage === "number" ? item.percentage / 100 : 0}
                  onClick={() => detalleCupones(item.id)}
                />
                ))}
              </>
            )}
          </QueryState>
        </div>
      )}
    </PageWrapper>
  );
};

export default Resumen;
